export const toTitleCase = (str: string) => {
  return (
    str
      // replace first char with upper case
      .replace(/^./, (match) => match.toUpperCase())
      .trim()
  );
};
